import React from 'react';

import ModalHeaderV2 from './modal-header-v2';

import '../css/xsell-modal.less';
import '../css/tabs-v2-summary.less';

const TabsV2Summary = ({ productInfo, isProductPC, isSmb, device, className }) => {
    let offerMsg = 'Get 5% off monitors and accessories w/ purchase of a PC.';
	return(
		<div className={`summary-wrapper${className ? ' ' + className : ''}`}>
			<ModalHeaderV2 productInfo={productInfo} device={device} />
            <div className={`offer-msg${isProductPC ? ' pc' : ''}${isSmb ? ' business' : 'consumer'}`}>{offerMsg}</div>

		</div>
	)
}

export default TabsV2Summary;
